// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import { CognitoIdentityProviderClient, InitiateAuthCommand,  ForgotPasswordCommand, 
    ConfirmForgotPasswordCommand, RespondToAuthChallengeCommand, GlobalSignOutCommand} from "@aws-sdk/client-cognito-identity-provider";
  import config  from '../utils/config';
  

  
  export const cognitoClient = new CognitoIdentityProviderClient({
    region: config.region,
  });
  
  export function signIn  (username, password, setloginstate, setLoading) {
    const params = {
      AuthFlow: "USER_PASSWORD_AUTH",
      ClientId: window.clientId,
      AuthParameters: {
        USERNAME: username,
        PASSWORD: password,
      },
    };
  
    const command = new InitiateAuthCommand(params);
    cognitoClient.send(command).then((responce) =>{
      if (responce.ChallengeName){
        sessionStorage.setItem("Session", responce.Session)
        setloginstate(responce.ChallengeName);
      } else if (responce.AuthenticationResult.IdToken) {
        parseTokens(responce);
        window.location.href = window.rootURL
        
      }
    }
  
      ).catch((error)=> {
        if (["NotAuthorizedException", "UserNotFoundException"].includes(error.__type)  ){
        console.log("Sign in failed check username or password");
        alert("Sign in failed check username or password");
        setLoading(false);
        }
        else {
          alert("Sign in failed for internal error");
          setLoading(false);
          console.log(error);
        }
  
    //Verify the token here?
    //const testparams = { "AccessToken" : sessionStorage['accessToken'] };
    //const testcommand = new GetUserCommand(params);
  });
     
    
   
  };
  
  export function forgotPwd  (username, setStatus) {
    const params = {
        ClientId: window.clientId, // required
        Username: username, // required
    };
  
    const command = new ForgotPasswordCommand(params);
    cognitoClient.send(command)
    .then(({ CodeDeliveryDetails } ) => {
      if (CodeDeliveryDetails) {
        console.log(CodeDeliveryDetails);
        setStatus("code")
        alert("A reset code has been sent to the Email regesterd")
        return CodeDeliveryDetails;
      }  
    }).catch((error) => {
      if (["CodeDeliveryFailureException","UserNotFoundException"].includes(error.__type)){
        console.log("Failed to deliver reset code");
        alert("Failed to deliver reset code");
      } else {
        console.log(`Internal Error ${error}`);
        alert("Internal Error");
      }
    });
  
  
  
  };
  
  export function ResetPwd  (username, password, code, setstatus) {
    const params ={
      ClientId: window.clientId, // required
      Username: username, // required
      ConfirmationCode: code, // required
      Password: password // required
    }
  
    const command = new ConfirmForgotPasswordCommand(params);
  
    cognitoClient.send(command).then((response)=> {
        if (response) 
          {
          console.log(response);
          setstatus("init");
          }
      }).catch((error)=> {
        if("ExpiredCodeException" === error.__type){
          alert("code expired please request another code");
          console.log("code expired please request another code");
        }else if (["CodeMismatchException","UserNotFoundException"].includes(error.__type)){
          alert("Failed to reset password");
          console.log("Failed to reset password");
        } else if (["InvalidPasswordException","InvalidParameterException"].includes(error.__type)) {
          alert("Password supplied doens't meet criteria");
        
        } else {
        alert("internal Error");
        console.log(`internal Error ${error}`);
        }
    });
  };
  
  export function ResetInitalPwd (ChallengeName, username, newPassword, setState) {
  
    const params ={
      Session: sessionStorage.getItem("Session"),
      ChallengeName: ChallengeName,
      ClientId: window.clientId,
      ChallengeResponses: { 
        USERNAME: username,
        NEW_PASSWORD: newPassword}
    }
    const command = new RespondToAuthChallengeCommand(params)
    cognitoClient.send(command).then((responce) => {
      if (responce.AuthenticationResult.IdToken){
        parseTokens(responce);
      // setState("init");
      window.location.href = window.rootURL
    };
    }).catch((error)=>{
      console.log(error);
      alert("Internal Error setting new password");
      setState("init");
        
    });
  }
  
export function LenelS2Connect(code) {
  const header = {
    "Content-Type": "application/x-www-form-urlencoded",
  };

  const body = new URLSearchParams({
    grant_type: "authorization_code",
    client_id: config.clientId,
    code: code,
    redirect_uri: config.redirect_page,
  });

  fetch(config.cogdomain + "/token", {
    headers: header,
    body: body,
    mode: "cors",
    method: "POST",
  })
    .then((responce) => {
      if (responce.status === 200) {
        const tokens = responce.json();
        return tokens;
      }
    })
    .then((tokens) => {
      if (tokens !== undefined) {
        const req = {
          AuthenticationResult: {
            IdToken: tokens.id_token,
            AccessToken: tokens.access_token,
            RefreshToken: tokens.refreshToken,
          },
        };
        parseTokens(req);
        window.location.href = window.rootURL;
      }
    });
}
function parseTokens(response) {
  const id_token = JSON.parse(
    atob(response.AuthenticationResult.IdToken.split(".")[1])
  );
  sessionStorage.setItem(
    "idToken",
    response.AuthenticationResult.IdToken || ""
  );
  sessionStorage.setItem(
    "accessToken",
    response.AuthenticationResult.AccessToken || ""
  );
  // sessionStorage.setItem("refreshToken", response.AuthenticationResult.RefreshToken || '');
  sessionStorage.setItem("username", id_token["name"]);
  if (typeof id_token["custom:lisa_access"] === "string") {
    sessionStorage.setItem("Help", true);
    sessionStorage.setItem("Query", false);
    sessionStorage.setItem("Control", false);
  } else {
    const claims = JSON.parse(id_token["custom:lisa_access"]);
    sessionStorage.setItem("Help", claims["Help"] || false);
    sessionStorage.setItem("Query", claims["Query"] || false);
    sessionStorage.setItem("Control", claims["Control"] || false);
  }
  const disclaimerPastStatus = id_token["custom:disclaimer_date"];
  sessionStorage.setItem("disclaimerPastStatus", disclaimerPastStatus || "");
  const eulaPastStatus = id_token["custom:eula_date"];
  sessionStorage.setItem("eulaPastStatus", eulaPastStatus || "");
}
export function logout(e) {
  const access_token = sessionStorage.getItem("accessToken");
  sessionStorage.clear();
  const input = { AccessToken: access_token };

  const command = new GlobalSignOutCommand(input);
  cognitoClient
    .send(command)
    .then()
    .catch((e) => {
      if (e.name !== "NotAuthorizedException") {
        console.log(e.name);
      }
    })
    .finally(() => window.location.reload());

  //window.location.href = '/login';
}
